import {useContext, useEffect, useState} from "react";
import {ModalContext} from "../../../utils/modal/ModalProvider";
import styles from "../../../utils/modal/DetailModal.module.css";
import {IAM_SERVER_AUTH_TOKEN_POLICY, IAM_SERVER_SERVICE, IAM_SERVER_SERVICE_AUTH, IAM_SERVER_SERVICE_PAGE, IAM_SERVER_SERVICE_PAGEAUTH} from "../../../utils/Config";
import axios from "../../../utils/api/axios";
import {DialogEnum, showDialog} from "../../../utils/dialog/Dialog";
import Switch from "@mui/material/Switch";
import Loading from "../../../utils/loading/Loading";
import { containsXss } from "../../../utils/security/XssFilter";



/**
 * 권한 상세정보 모달 Container
 * @param id
 * @param update
 * @returns {JSX.Element}
 * @constructor
 */
export const AuthDetailModal = ({id, update}) => {
    const {closeModal} = useContext(ModalContext);
    const [loading, setLoading] = useState(true);
    const [isNull, setIsNull] = useState(false); //빈 값 확인

    const [formData, setFormData] = useState({
        authorityId: 0,
        serviceId: '',
        authorityName: '',
        notModAuthority: '',
        authorityType: '',
        authorityEngName: '',
        authorityDiscript: ''
    });

    useEffect(() => {
        // id로 권한 정보 조회
        const url = IAM_SERVER_SERVICE_AUTH + "/get/" + id;
        axios.get(url)
            .then((res) => {
                setFormData({
                    authorityId: res.data.data.authorityId,
                    serviceId: res.data.data.serviceId,
                    authorityName: res.data.data.authorityName,
                    authorityEngName: res.data.data.authorityEngName,
                    authorityDiscript:res.data.data.authorityDiscript,
                    notModAuthority:res.data.data.notModAuthority,
                    authorityType:res.data.data.authorityType,
                });
            })
            .catch((e) => {
                showDialog(DialogEnum.DEFAULT, "실패", "권환 조회에 실패했습니다.");
            })
            .finally(() => {
                setLoading(false);
            })         
    }, []);

    const handleChange = (e) => {
        const {name, value} = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value
        }));
    }


    // 사용자 상세정보 수정 요청 API
    const handleModify = () => {
        const url = IAM_SERVER_SERVICE_AUTH + "/update";
        const params = Object.assign({}, formData);

        for (let key in formData) {
            const value = formData[key];

            if (key !== 'authorityId' && key !== 'authorityDiscript' && value === '') {
                setIsNull(true);
                return;
            }

            // 숫자는 검사 안함
            if (key !== 'authorityId' && typeof value === 'string' && containsXss(value)) {
                setFormData((prevState) => ({
                    ...prevState,
                    [key]: ''
                }));
                setIsNull(true);
                showDialog(DialogEnum.FAIL, "경고", "올바른 값을 입력해 주세요.");
                return;
            }
        }
        
        axios.post(url, params)
            .then((res) => {
                showDialog(DialogEnum.SUCCESS, "성공", res.data.message, closeModal);
                update();
            })
            .catch((e) => {
                showDialog(DialogEnum.DEFAULT, "실패", e.response.data.resultMessage);
            })
    }

    
    const handleDelete = () => {
        const url = IAM_SERVER_SERVICE_AUTH + "/delete/"+formData.authorityId;

        axios.post(url)
            .then((res) => {
                showDialog(DialogEnum.SUCCESS, "성공", res.data.message, closeModal);
                update();
            })
            .catch((e) => {
                showDialog(DialogEnum.DEFAULT, "실패", e.response.data.resultMessage);
            })
    }


    return (
        <div style={{overflow: "auto"}}>
            {loading ? <Loading/> :
                <div>
                    <ul className={styles.layer__listWrap}>
                        <li className={styles.layer__list}>
                            <p className={styles.layer__listTit}>권한 명</p>
                            <input className={styles.layer__listInput}
                                type={"text"}
                                name={"authorityName"}
                                value={formData.authorityName}
                                readOnly={formData.notModAuthority}
                                onChange={handleChange}/>
                        </li>
                        <li className={styles.layer__list}>
                            <p className={styles.layer__listTit}>영문 명</p>
                            <input className={styles.layer__listInput}
                                type={"text"}
                                name={"authorityEngName"}
                                value={formData.authorityEngName}
                                readOnly={formData.notModAuthority}
                                onChange={handleChange}/>  
                        </li>
                        {formData.notModAuthority ? 
                            <li className={styles.layer__list}>
                                <p className={styles.layer__listTit}>권한 타입</p>
                                <input className={styles.layer__listInput}
                                    type={"text"}
                                    name={"authorityType"}
                                    value={formData.authorityType}
                                    readOnly={true}
                                    onChange={handleChange}/>  
                            </li>
                        : <li className={styles.layer__list}>
                            <p className={styles.layer__listTit}>권한 타입</p>
                            <select
                                className={styles.layer__listInput}
                                name="authorityType"
                                value={formData.authorityType}
                                onChange={(e) => handleChange(e.target.value)}
                            >
                                <option value="SERVICE">서비스 유저 (SERVICE)</option>
                                <option value="TENANT">테넌트 유저 (TENANT)</option>
                                <option value="USER">일반 유저 (USER)</option>
                            </select>
                        </li>
                        }
                        <li className={styles.layer__list}>
                            <p className={styles.layer__listTit}>설명</p>
                            <textarea
                                className={styles.layer__listInput}
                                name={"authorityDiscript"}
                                value={formData.authorityDiscript}
                                onChange={handleChange}
                                rows={4} // 원하는 줄 수 조절 가능
                            />
                        </li>
                    </ul>


                    {isNull ? <div className={`${styles.layer__text} ${styles.warning}`}>빈 칸을 확인해 주세요.</div> : null}
                    {!formData.notModAuthority ?  
                        <div className={styles.layer__sensorBtnBox}>
                            <button className={styles.layer__cancleBtn} onClick={handleDelete}>삭제</button>
                            <button className={styles.layer__modifyBtn} onClick={handleModify}>수정</button>                        
                        </div>
                        : null
                    }
                    
                </div>
            }
        </div>
    );
}